export default __webpack_public_path__ + "assets/f14305fe23b34f09f08708054f51827d.svg";